import { render } from "./TxTitleComponent.vue?vue&type=template&id=382d089a&scoped=true"
import script from "./TxTitleComponent.vue?vue&type=script&lang=js"
export * from "./TxTitleComponent.vue?vue&type=script&lang=js"

import "./TxTitleComponent.vue?vue&type=style&index=0&id=382d089a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382d089a"]])

export default __exports__